export const keywordTypes = {
    keyword: 'keyword',
    url: 'url',
};
